// Static config — Pizzeria da Sofia (lingua-agnostico)
export const SITE = {
  name: "Pizzeria da Sofia",
  phone: "371 440 9232",
  phoneIntl: "+393714409232",
  whatsappBase: "https://wa.me/393714409232",
  address: "Via XXIII Marzo 1849, 147",
  city: "28100 Novara (NO)",
  hours: [
    { dayKey: "mon", value: "12:00 – 14:30 · 19:00 – 22:30" },
    { dayKey: "tue", value: "12:00 – 14:30 · 19:00 – 22:30" },
    { dayKey: "wed", value: "12:00 – 14:30 · 19:00 – 22:30" },
    { dayKey: "thu", value: "12:00 – 14:30 · 19:00 – 22:30" },
    { dayKey: "fri", value: "12:00 – 14:30 · 19:00 – 22:30" },
    { dayKey: "sat", value: "12:00 – 14:30 · 19:00 – 22:30" },
    { dayKey: "sun", value: "12:00 – 14:30 · 19:00 – 22:30" },
  ],
  rating: { stars: 4.6, count: 350 },
  socials: {
    instagram: "https://www.instagram.com/pizzeriadasofia",
    facebook: "https://www.facebook.com/profile.php?id=100084253600478",
    tiktok: "https://www.tiktok.com/@pizzeriadasofia",
  },
  images: {
    logo: "https://customer-assets.emergentagent.com/job_da-sofia-pizza/artifacts/fmhjan3v_IMG_2197.jpeg",
    hero: "https://customer-assets.emergentagent.com/job_da-sofia-pizza/artifacts/s6wof3oj_IMG_2198.jpeg",
    pizzaSiciliana: "https://customer-assets.emergentagent.com/job_da-sofia-pizza/artifacts/s6wof3oj_IMG_2198.jpeg",
    pizzaDiavola: "https://customer-assets.emergentagent.com/job_da-sofia-pizza/artifacts/0jn4vdkr_IMG_2199.jpeg",
    pizzaPesto: "https://customer-assets.emergentagent.com/job_da-sofia-pizza/artifacts/g3hs5meb_IMG_2201.jpeg",
    secondiPesce: "https://customer-assets.emergentagent.com/job_da-sofia-pizza/artifacts/4y1qn5kk_IMG_2200.jpeg",
  },
};

export const waLink = (msg) =>
  `${SITE.whatsappBase}?text=${encodeURIComponent(msg || "Ciao")}`;
